import { ListChildComponentProps } from 'react-window'

interface Props extends ListChildComponentProps {}

// This component is only needed to pass the index of the drag and drop library
// to the virtualized tree rows
const ListRowWrapper = ({ index, data: { component: Node, getRecordData, treeData }, style, isScrolling }: Props) => {
  const data = getRecordData(index)

  return <Node isScrolling={isScrolling} style={style} treeData={treeData} index={index} {...data} />
}

export { ListRowWrapper }
